import React from 'react';
import { Link } from 'react-router-dom';

const EXTERNAL_LINKS = {
  privacy: 'https://www.bkfc.com/privacy-policy',
  terms: 'https://www.bkfc.com/terms-of-use',
  about: 'https://www.bkfc.com/about',
  contact: 'https://www.bkfc.com/contact',
};

const Footer = () => {
  return (
    <footer className="bg-secondary border-t border-gray-border py-12 px-6">
      <div className="container mx-auto">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-display uppercase text-white mb-4">BKFC+</h3>
            <p className="text-text-muted text-sm mb-4">
              Your destination for bare knuckle fighting championships. Live events, past fights,
              and exclusive content.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-lg font-display uppercase text-white mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-text-muted hover:text-accent transition-colors text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/events"
                  className="text-text-muted hover:text-accent transition-colors text-sm"
                >
                  Events
                </Link>
              </li>
              <li>
                <Link
                  to="/fighters"
                  className="text-text-muted hover:text-accent transition-colors text-sm"
                >
                  Fighters
                </Link>
              </li>
              <li>
                <Link
                  to="/my-lists"
                  className="text-text-muted hover:text-accent transition-colors text-sm"
                >
                  My List
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-display uppercase text-white mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href={EXTERNAL_LINKS.contact}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-muted hover:text-accent transition-colors text-sm"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  href={EXTERNAL_LINKS.about}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-muted hover:text-accent transition-colors text-sm"
                >
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-display uppercase text-white mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href={EXTERNAL_LINKS.privacy}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-muted hover:text-accent transition-colors text-sm"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href={EXTERNAL_LINKS.terms}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-muted hover:text-accent transition-colors text-sm"
                >
                  Terms of Use
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-text-muted text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} Bare Knuckle Fighting Championships, Inc. All rights
              reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
